<template>
    <div class="package-card">
        <div class="step-heading">What's your focus?</div>
        <div class="step-sub">Pick the areas that fit your classroom or your goals — we'll recommend matching courses on the next step. You can still choose any course in the catalog.</div>

        <div class="has-text-grey mt-5" v-if="loading"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Loading course areas...</div>

        <b-field class="mt-5" v-else>
            <template #label>
                Subject areas &amp; course types <span class="optional">(pick any that apply)</span>
            </template>
            <div class="chips">
                <button class="chip"
                        v-for="category in categories"
                        :key="'focus-' + category.id"
                        :class="{'is-selected': isSelected(category)}"
                        @click="togglePkgFocusCategory(category)">
                    {{ category.title }}<span class="chip-count">{{ category.count }}</span>
                </button>
            </div>
        </b-field>

        <div class="step-actions">
            <b-button type="is-text" @click="$emit('back')"><i class="fas fa-arrow-left mr-2"></i>Back</b-button>
            <b-button type="is-primary" size="is-medium" :disabled="!pkgFocusCategories.length" @click="$emit('continue')">Continue to Courses<i class="fas fa-arrow-right ml-2"></i></b-button>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import {PACKAGE_CERT_ID} from "@/constants/packages";

    export default {
        name: "StepFocus",
        props: {
            courses: {type: Array, default: () => []},
            loading: {type: Boolean, default: false}
        },
        computed: {
            ...mapGetters(['pkgFocusCategories']),
            // The real catalog taxonomy, derived from the loaded package
            // courses' category assignments — only areas with at least one
            // eligible course appear, with live counts
            categories() {
                const map = new Map();
                for (const course of this.courses) {
                    for (const category of (course.categories || [])) {
                        if (category.certification_id !== PACKAGE_CERT_ID) continue;
                        const entry = map.get(category.id) || {id: category.id, title: category.title, count: 0};
                        entry.count++;
                        map.set(category.id, entry);
                    }
                }
                return [...map.values()].sort((a, b) => a.title.localeCompare(b.title));
            }
        },
        methods: {
            ...mapMutations(['togglePkgFocusCategory']),
            isSelected(category) {
                return this.pkgFocusCategories.some(c => c.id === category.id);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .optional {
        font-weight: normal;
        color: #7a8a9d;
    }

    .chip-count {
        margin-left: 6px;
        font-size: 0.7rem;
        font-weight: normal;
        opacity: 0.7;
    }
</style>
